import { useCallback } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router'

import { useTelegramBackButton } from '@/telegram'

const HOME_PATH = '/'

/** Root layout: owns the native Telegram back button so pages never manage it themselves. */
export function AppLayout() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const isHomePage = pathname === HOME_PATH

  const navigateBack = useCallback(() => {
    // A deep link has no history entry to go back to, so fall back to the home page.
    const hasHistoryEntry = window.history.state !== null && window.history.length > 1
    if (hasHistoryEntry) {
      void navigate(-1)
      return
    }
    void navigate(HOME_PATH, { replace: true })
  }, [navigate])

  useTelegramBackButton(!isHomePage, navigateBack)

  return (
    <div className="mx-auto flex min-h-viewport w-full max-w-md flex-col px-4 pt-safe pb-safe">
      <Outlet />
    </div>
  )
}
